import queryString from 'query-string';
import { useBuilding } from 'app/shared/contexts/building';
import { useUser } from 'app/shared/contexts/user';
import { useApi } from 'app/shared/contexts/api';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

export interface UseMicroFrontendParams {
  withLocale: boolean;
}

export const useMicroFrontendParams = (): string => {
  const intl = useIntl();
  const { user } = useUser();
  const { building } = useBuilding();
  const { authToken, apiUrl } = useApi();
  const { appBrand } = useParams<{ appBrand: string }>();

  const miniAppProps = {
    appBrand: appBrand || 'HQO',
    buildingUuid: building?.uuid,
    locale: intl.locale,
    authToken,
    firstName: user?.first_name,
    lastName: user?.last_name,
    userId: user?.id,
    userUuid: user?.uuid,
    apiUrl: apiUrl.replace('/api', ''),
  };

  return queryString.stringify(miniAppProps);
};
